import type { User } from "../types/auth";

interface Credential {
  password: string;
  user:     User;
}

export const CREDENTIALS: Record<string, Credential> = {
  master: {
    password: "master@2025",
    user: { username: "master", role: "master", label: "Master Admin" },
  },
  damascus: {
    password: "damascus@2025",
    user: { username: "damascus", role: "city", city: "Damascus", label: "Damascus" },
  },
  aleppo: {
    password: "aleppo@2025",
    user: { username: "aleppo", role: "city", city: "Aleppo", label: "Aleppo" },
  },
  homs: {
    password: "homs@2025",
    user: { username: "homs", role: "city", city: "Homs", label: "Homs" },
  },
  hama: {
    password: "hama@2025",
    user: { username: "hama", role: "city", city: "Hama", label: "Hama" },
  },
  daraa: {
    password: "daraa@2025",
    user: { username: "daraa", role: "city", city: "Daraa", label: "Daraa" },
  },
  deirezor: {
    password: "deirezor@2025",
    user: { username: "deirezor", role: "city", city: "Deir ez-Zor", label: "Deir ez-Zor" },
  },
  latakia: {
    password: "latakia@2025",
    user: { username: "latakia", role: "city", city: "Latakia", label: "Latakia" },
  },
  idlib: {
    password: "idlib@2025",
    user: { username: "idlib", role: "city", city: "Idlib", label: "Idlib" },
  },
};

/** Returns the User if credentials match, otherwise null */
export const authenticate = (username: string, password: string): User | null => {
  const entry = CREDENTIALS[username.toLowerCase().trim()];
  if (!entry) return null;
  if (entry.password !== password) return null;
  return entry.user;
};